module.exports = __webpack_public_path__ + "img/ouvrages.9a01e709.svg";